import Image from 'next/image';

import { INITIAL_FALLBACK_ICON_DATA_URL } from './constants';
import useFallbackIcon from './hooks/useFallbackIcon';

import type { ImageProps } from 'next/image';

type SpriteBaseIconProps = Omit<ImageProps, 'placeholder'> & {
  fontSize: number;
  placeholder: string;
};

const SpriteBaseIcon = (props: SpriteBaseIconProps) => {
  const { fontSize, placeholder, alt, ...others } = props;
  const { handleError } = useFallbackIcon(placeholder);
  // 성능을 위해 40px 이상일 경우에만 플레이스홀더를 사용합니다.
  // next/image: Image with src "..." is smaller than 40x40. Consider removing the "placeholder" property to improve performance.
  const placeholderType = fontSize > 40 ? 'blur' : 'empty';
  const blurDataURL = fontSize > 40 ? INITIAL_FALLBACK_ICON_DATA_URL : undefined;

  return (
    <Image
      {...others}
      alt={alt}
      placeholder={placeholderType}
      blurDataURL={blurDataURL}
      width={fontSize}
      height={fontSize}
      loading="lazy"
      unoptimized
      onError={handleError}
    />
  );
};

export default SpriteBaseIcon;
